import { render, staticRenderFns } from "./ModalPendente.vue?vue&type=template&id=9e8d2562&scoped=true"
import script from "./ModalPendente.vue?vue&type=script&lang=js"
export * from "./ModalPendente.vue?vue&type=script&lang=js"
import style0 from "./ModalPendente.vue?vue&type=style&index=0&id=9e8d2562&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8d2562",
  null
  
)

export default component.exports